import React from "react";
import styled from "styled-components";

import { Button } from "@/components/Form";
import { IThemeProps } from "@/styles";

export type MessageProps = {
  text?: string;
  buttonText?: string;
  onCtaClick?: () => void;
  onLoad?: () => void;
};

export class PollMessage extends React.Component<MessageProps> {
  public render(): JSX.Element {
    const { text, buttonText, onCtaClick } = this.props;

    return (
      <React.Fragment>
        <MessageBox>
          <WhiteBox>
            <Text>{text}</Text>
          </WhiteBox>
        </MessageBox>
        {buttonText && onCtaClick && (
          <Button onClick={onCtaClick}>{buttonText}</Button>
        )}
      </React.Fragment>
    );
  }

  public componentDidMount(): void {
    const { onLoad } = this.props;
    if (onLoad) {
      setTimeout(() => onLoad(), 3000);
    }
  }
}

const MessageBox = styled.div`
  align-self: flex-start;
  display: flex;
  justify-content: center;
  margin: 20px;
`;

const WhiteBox = styled.div`
  background-color: ${(props: IThemeProps) => props.theme.colors.white};
  padding: 20px;
  width: 100%;
`;

const Text = styled.p`
  color: ${(props: any) => props.theme.colors.fontText};
  font-size: ${(props: any) => props.theme.typography.h600};
  line-height: ${(props: any) => props.theme.typography.h800};
`;
